import Event = createjs.Event;
import Container = createjs.Container;

export class SimplePreloadAnim extends Container {
    // TODO: @HTML5 - use exported library asset reference here.
    // private _ggsLogo: GGS_Logo;
    private _ggsLogo: any;

    constructor() {
        super();
        this.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));
        this.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemovedFromStage));
    }

    private onAddedToStage(event: Event): void {
        if (!this._ggsLogo) {
            // this._ggsLogo = new GGS_Logo();
            this._ggsLogo = new Container();

            this.addChild(this._ggsLogo);

            this.resizeLogo();

            this.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.updatePreloadAnim));

            this.stage.addEventListener(Event.RESIZE, this.bindFunction(this.resizeLogo));
        }
    };

    private onRemovedFromStage(event: Event): void {
        if (this._ggsLogo) {
            this.removeChild(this._ggsLogo);

            this._ggsLogo = null;

            this.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.updatePreloadAnim));

            this.stage.removeEventListener(Event.RESIZE, this.bindFunction(this.resizeLogo));
        }
    };

    private updatePreloadAnim(event: Event): void {
        if (this._ggsLogo) {
            this._ggsLogo.spinner.rotation += 5;
        }
    };

    private resizeLogo(event: Event = null): void {
        if (this._ggsLogo) {
            this._ggsLogo.x = this.stage.stageWidth / 2;
            this._ggsLogo.y = this.stage.stageHeight / 2;

            this._ggsLogo.bg.width = this.stage.stageWidth;
            this._ggsLogo.bg.height = this.stage.stageHeight;
        }
    };
}

